<template>
  <div class="scroll-container" ref="container" :data-direction="isHorizontal ? 'horizontal' : 'vertical'"
    :data-reverse="isReverse ? 'true' : 'false'" :class="isHorizontal ? 'aic' : 'jcc'">
    <div class="line" :style="{
      width: isHorizontal ? '100%' : '3px',
      height: isHorizontal ? '3px' : '100%',
      backgroundColor: color,
    }"></div>
    <!-- 下移动 -->
    <div class="mask" :style="{ animationDuration: animationDuration, flexDirection: isHorizontal ? 'row' : 'column'}">
      <svg  v-for="dot in dots" :key="dot" t="1730968058552" class="dot"
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8125"
        xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28">
        <path :fill="color" d="M192 384l320 384 320-384H192z" p-id="8126" data-spm-anchor-id="a313x.search_index.0.i5.6e8f3a813yS0fJ"
          class="selected"></path>
      </svg>
      <svg v-for="dot in dots" :key="dot+10000000" t="1730968058552" class="dot"
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8125"
        xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28">
        <path :fill="color" d="M192 384l320 384 320-384H192z" p-id="8126" data-spm-anchor-id="a313x.search_index.0.i5.6e8f3a813yS0fJ"
          class="selected"></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isHorizontal: { type: Boolean, default: true },   // 控制水平true或垂直false滚动 
    isReverse: { type: Boolean, default: false },     // 控制滚动方向true下右 false上左
    animationSpeed: { type: String, default: '20s' },  // 动画速度
    color: { type: String, default: '#000' }  // 颜色
  },
  data() {
    return {
      dots: [],               // 存储点的数组
      dotSize: 40             // 每个矩形的尺寸（包含间距）
    };
  },
  computed: {
    animationDuration() {
      return this.animationSpeed;
    }
  },
  methods: {
    generateDots() {
      // 获取容器尺寸（宽度或高度）
      const containerSize = this.isHorizontal
        ? this.$refs.container.offsetWidth
        : this.$refs.container.offsetHeight;

      // 根据容器尺寸计算需要的点数
      const dotsCount = Math.ceil(containerSize / this.dotSize) + 5;

      // 更新 dots 数组
      this.dots = Array.from({ length: dotsCount }, (_, i) => i);
    }
  },
  mounted() {
    // 初次加载时生成点
    this.generateDots();
    // 窗口大小变化时重新生成点
    window.addEventListener('resize', this.generateDots);
  },
  beforeDestroy() {
    // 移除窗口监听器，防止内存泄漏
    window.removeEventListener('resize', this.generateDots);
  }
};
</script>

<style lang="less" scoped>
@backgroundColor: #002060;
@dotColor: pink;
@gap: 20px;

.jcc {
  justify-content: center;
}

.aic {
  align-items: center;
}

.scroll-container {
  display: flex;
  overflow: hidden;
  position: relative;

  .mask {
    display: flex;
    gap: @gap;
    animation: moveDots linear infinite;
    position: absolute;
  }
}

/* 动态生成 keyframes */
.scroll-container[data-direction="horizontal"][data-reverse="false"] .mask {
  animation-name: horizontalForward;
  .dot{
    transform: rotate(90deg);
  }
}

.scroll-container[data-direction="horizontal"][data-reverse="true"] .mask {
  animation-name: horizontalReverse;
  .dot{
    transform: rotate(270deg);
  }
}

.scroll-container[data-direction="vertical"][data-reverse="false"] .mask {
  animation-name: verticalForward;
  .dot{
    transform: rotate(180deg);
  }
}

.scroll-container[data-direction="vertical"][data-reverse="true"] .mask {
  animation-name: verticalReverse;
  .dot{
    transform: rotate(0deg);
  }
}

/* 水平正方向（从左到右） */
@keyframes horizontalForward {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* 水平反方向（从右到左） */
@keyframes horizontalReverse {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

/* 垂直正方向（从上到下） */
@keyframes verticalForward {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

/* 垂直反方向（从下到上） */
@keyframes verticalReverse {
  0% {
    transform: translateY(-50%);
  }

  100% {
    transform: translateY(0);
  }
}</style>
